import {
    ADDORUPDATELOADLIMIT_SUCCESS,
    ADDORUPDATELOADLIMIT_FAILED,
    RESET_ADDORUPDATELOADLIMIT,
    LOADING_ADDORUPDATELOADLIMIT,
    NETWORK_ERROR_ADDORUPDATELOADLIMIT,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDORUPDATELOADLIMIT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case ADDORUPDATELOADLIMIT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case ADDORUPDATELOADLIMIT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_ADDORUPDATELOADLIMIT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_ADDORUPDATELOADLIMIT:
            return (state = initialState);
        default:
            return state;
    }
};
